import React, { useState, useEffect, useCallback } from 'react';
import { Button } from 'src/components/button';
import FormInput from 'src/components/form-input';
import { useGlobalContext } from 'src/context/global/use-global-context';

function SignIn() {
  const { login } = useGlobalContext();
  const [isLoading, setIsLoading] = useState(false);

  const [data, setData] = useState({
    email: '',
    password: '',
  });

  const [error, setError] = useState('');

  const onLogin = useCallback(async () => {
    setIsLoading(true);
    const { success, message } = await login({
      email: data.email,
      password: data.password,
    });
    if (!success) {
      setError(message);
    }
    setIsLoading(false);
  }, [data, login]);

  const handleKeyDown = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Enter') {
        onLogin();
      }
    },
    [onLogin],
  );

  useEffect(() => {
    document.addEventListener('keydown', handleKeyDown);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
    };
  }, [handleKeyDown]);

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center px-6 py-12 lg:px-8">
      <div className="sm:mx-auto sm:w-full sm:max-w-sm">
        <img alt="Tronteq" src="./logo.png" className="mx-auto h-10 w-auto" />
        <h2 className="mt-4 text-center text-2xl/9 font-bold tracking-tight text-gray-900">
          Sign in to your account
        </h2>
      </div>
      {error && (
        <div className="mt-4 sm:mx-auto sm:w-full sm:max-w-sm">
          <p className="text-red-500">{error}</p>
        </div>
      )}
      <div className="mt-4 sm:mx-auto sm:w-full sm:max-w-sm">
        <div className="mb-4">
          <FormInput
            id="email"
            label="Email"
            name="email"
            type="text"
            required
            autoComplete="username"
            value={data.email}
            data-testid="sign-in-email-input"
            onChange={(e) => {
              setData({ ...data, email: e.target.value });
              setError('');
            }}
          />
        </div>
        <div className="mb-4">
          <FormInput
            id="password"
            label="Password"
            name="password"
            type="password"
            required
            autoComplete="current-password"
            value={data.password}
            data-testid="sign-in-password-input"
            onChange={(e) => {
              setData({ ...data, password: e.target.value });
              setError('');
            }}
          />
        </div>
        <div>
          <Button
            data-testid="sign-in-button"
            onClick={onLogin}
            disabled={!data.email || !data.password || isLoading}
            className="w-full"
          >
            {isLoading ? 'Signing in...' : 'Sign in'}
          </Button>
        </div>
      </div>
    </div>
  );
}

export default SignIn;
